'use client';

import { Box, Stack } from '@mui/material';
import type { ReactNode } from 'react';

import Headline from '../Headline';

interface Props {
  backButton?: ReactNode;
  title?: ReactNode | string;
  customTitle?: ReactNode | string;
  superTitle?: ReactNode;
  actionMenu?: ReactNode;
}

export default function ({ backButton, customTitle, title, superTitle, actionMenu }: Props) {
  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        alignItems: 'center',
        px: 2,
        minHeight: 40,
      }}
    >
      {backButton}
      <Stack sx={{ flex: '1 1 auto' }}>
        {superTitle && <Box sx={{ mb: 0.5 }}>{superTitle}</Box>}
        {customTitle ? customTitle : null}
        {title && (
          <Headline
            size="sm"
            component="h1"
          >
            {title}
          </Headline>
        )}
      </Stack>
      {actionMenu}
    </Stack>
  );
}
